/**
 * Multi-Cloud Control Catalog Service
 */

import api from './api';

// Catalog endpoints
export const getCatalogs = async () => {
  const response = await api.get('/catalog/catalogs');
  return response.data;
};

export const getCatalog = async (catalogId) => {
  const response = await api.get(`/catalog/catalog/${catalogId}`);
  return response.data;
};

export const getCatalogDashboard = async () => {
  const response = await api.get('/catalog/dashboard');
  return response.data;
};

export const getControls = async (params = {}) => {
  const response = await api.get('/catalog/controls', { params: { limit: 200, ...params } });
  return response.data;
};

export const getControl = async (controlId) => {
  const response = await api.get(`/catalog/controls/${controlId}`);
  return response.data;
};

export const createControl = async (data, catalogId = 'beskar-multi-cloud-baseline') => {
  const response = await api.post(`/catalog/controls?catalog_id=${catalogId}`, data);
  return response.data;
};

export const updateControl = async (controlId, data, catalogId = 'beskar-multi-cloud-baseline') => {
  const response = await api.put(`/catalog/controls/${controlId}?catalog_id=${catalogId}`, data);
  return response.data;
};

export const deleteControl = async (controlId, catalogId = 'beskar-multi-cloud-baseline') => {
  const response = await api.delete(`/catalog/controls/${controlId}?catalog_id=${catalogId}`);
  return response.data;
};

export const importCatalog = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/catalog/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const exportCatalog = async (catalogId, format = 'yaml') => {
  const response = await api.get(`/catalog/export/${catalogId}?format=${format}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const syncCatalog = async () => {
  const response = await api.post('/catalog/sync');
  return response.data;
};

// Misconfigurations
export const getMisconfigurations = async (params = {}) => {
  const response = await api.get('/catalog/misconfigurations', { params });
  return response.data;
};

export const getMisconfigurationsSummary = async () => {
  const response = await api.get('/catalog/misconfigurations/summary');
  return response.data;
};

// Constants
export const CLOUD_PROVIDERS = [
  { value: 'aws', label: 'AWS', color: 'bg-orange-500' },
  { value: 'azure', label: 'Azure', color: 'bg-blue-500' },
  { value: 'gcp', label: 'GCP', color: 'bg-green-500' },
  { value: 'onprem', label: 'On-Prem', color: 'bg-gray-500' },
  { value: 'multi', label: 'Multi-Cloud', color: 'bg-purple-500' }
];

export const CONTROL_DOMAINS = [
  { value: 'access_control', label: 'Access Control' },
  { value: 'logging_monitoring', label: 'Logging & Monitoring' },
  { value: 'network_security', label: 'Network Security' },
  { value: 'data_protection', label: 'Data Protection' },
  { value: 'vulnerability_management', label: 'Vulnerability Management' },
  { value: 'incident_response', label: 'Incident Response' },
  { value: 'platform_hardening', label: 'Platform Hardening' }
];

export const SEVERITY_LEVELS = [
  { value: 'critical', label: 'Critical', color: 'bg-red-600' },
  { value: 'high', label: 'High', color: 'bg-orange-500' },
  { value: 'medium', label: 'Medium', color: 'bg-yellow-500' },
  { value: 'low', label: 'Low', color: 'bg-blue-500' },
  { value: 'info', label: 'Info', color: 'bg-gray-400' }
];

export const FRAMEWORKS = [
  { value: 'uspcf', label: 'USPCF' },
  { value: 'iso_27001', label: 'ISO 27001' },
  { value: 'nist_800_53', label: 'NIST 800-53' },
  { value: 'cis', label: 'CIS Benchmarks' },
  { value: 'pci_dss', label: 'PCI DSS' },
  { value: 'soc2', label: 'SOC 2' },
  { value: 'hipaa', label: 'HIPAA' },
  { value: 'gdpr', label: 'GDPR' }
];
